import React from 'react';
import { FormControl, Input, InputLabel } from '@mui/material';

interface FormFieldProps {
  icon: React.ReactNode;
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  required?: boolean;
  type?: string;
  onClearError?: () => void;
  disabled?: boolean;
  className?: string;
}

export const FormField: React.FC<FormFieldProps> = ({
  icon,
  label,
  value,
  onChange,
  error,
  required = false,
  type = 'text',
  onClearError,
  disabled = false,
  className = ''
}) => {
  return (
    <FormControl 
      sx={{ m: 2, marginTop: "2px" }} 
      variant="standard" 
      fullWidth
      className={className}
    >
      <InputLabel 
        htmlFor={`field-${label.replace(/\s+/g, '-').toLowerCase()}`} 
        style={{ display: "flex", alignItems: "center" }}
      >
        {icon}
        <span style={{ marginLeft: "10px" }}>{label}</span>
        {required && <span style={{ color: "#f04141", fontSize: "18px", marginLeft: "2px" }}>*</span>}
      </InputLabel>
      <Input
        id={`field-${label.replace(/\s+/g, '-').toLowerCase()}`}
        value={value}
        type={type}
        onChange={(e) => onChange(e.target.value)}
        onClick={onClearError}
        error={!!error}
        disabled={disabled}
        fullWidth
      />
      {error && (
        <p style={{ 
          color: "red", 
          marginTop: "5px", 
          marginLeft: "0px",
          fontSize: "0.875rem"
        }}>
          {error}
        </p>
      )}
    </FormControl>
  );
};